var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import OperationLine from './Model';
import { action, observable } from 'mobx';
import { api } from 'helpers/Api';
export default class OperationLinesStore {
    constructor() {
        this.data = [];
        this.loaded = false;
        this.set = (values) => {
            this.data = values.map((item) => new OperationLine(item));
            this.loaded = true;
            return this.data;
        };
        this.push = (value) => {
            this.data.push(new OperationLine(value));
        };
        this.replace = (value) => {
            this.data.splice(this.data.findIndex(f => f.id === value.id), 1, value);
        };
        this.findById = (id) => this.data.find(f => f.id === Number(id));
    }
    read(id) {
        // console.log('OperationLines/Store - read')
        if (id)
            return api.get('operationlines/' + id);
        return api.get('operationlines').then((value) => {
            // console.log('operationLines', value)
            return this.set(value);
            // return value
        });
    }
    create(value) {
        return api.post('operationlines', value).then(this.push);
    }
    update(id, value) {
        return api.put('operationlines/' + id, value).then(this.replace);
    }
    setData(data) {
        this.set(data);
    }
}
__decorate([
    observable
], OperationLinesStore.prototype, "data", void 0);
__decorate([
    observable
], OperationLinesStore.prototype, "loaded", void 0);
__decorate([
    action
], OperationLinesStore.prototype, "set", void 0);
__decorate([
    action
], OperationLinesStore.prototype, "push", void 0);
__decorate([
    action
], OperationLinesStore.prototype, "replace", void 0);
__decorate([
    action
], OperationLinesStore.prototype, "setData", null);



//////////////////
// WEBPACK FOOTER
// ./src/modules/OperationLines/Store.ts
// module id = 346
// module chunks = 0